<div class="wrapper">
	<h3>Checkout Integration Status:</h3>
	<div
		[class.padding-top]="
			order?.checkoutIntegrationStatus !== statusEnum.POSTPONED &&
			order?.checkoutIntegrationStatus !== statusEnum.REJECTED
		"
		[class.between]="
			order?.checkoutIntegrationStatus === statusEnum.POSTPONED ||
			order?.checkoutIntegrationStatus === statusEnum.REJECTED
		"
	>
		<p
			class="status"
			[class.green]="checkStatusGreen(order?.checkoutIntegrationStatus)"
			[class.red]="checkStatusRed(order?.checkoutIntegrationStatus)"
		>
			{{
				order?.checkoutIntegrationStatus === 'received'
					? 'Sent to the POS'
					: order?.checkoutIntegrationStatus
			}}{{ checkStatusGreen(order?.checkoutIntegrationStatus) ? '✅' : ''
			}}{{ checkStatusRed(order?.checkoutIntegrationStatus) ? '❌' : ''
			}}{{
				order?.checkoutIntegrationStatus === statusEnum.POSTPONED ? '⚠️ ' : ''
			}}
		</p>
		<button
			*ngIf="
				(order?.checkoutIntegrationStatus === statusEnum.REJECTED ||
					order?.checkoutIntegrationStatus === statusEnum.POSTPONED) &&
				!loading
			"
			(click)="sendToPOS()"
		>
			Send To POS 📤
		</button>
		<div class="loader-wrapper" *ngIf="loading">
			<div class="spinner"></div>
		</div>
	</div>
</div>
